(() => {
  const isDesktop = () => window.matchMedia('(min-width: 782px)').matches;

  const getHeaderShell = () => document.querySelector('.babaa-header-shell');

  const updateHeaderFixed = (scrollTop) => {
    getHeaderShell()?.classList.toggle('is-fixed', scrollTop > 1);
  };

  const bindNativeHeaderScroll = () => {
    const shell = getHeaderShell();
    if (!shell || shell.dataset.shopScrollBound) return;
    shell.dataset.shopScrollBound = 'true';

    const update = () => updateHeaderFixed(window.scrollY);
    update();
    window.addEventListener('scroll', update, { passive: true });
  };

  const initSmoothScroll = () => {
    const wrapper = document.getElementById('babaa-smooth-wrapper');
    const content = document.getElementById('babaa-smooth-content');
    if (!wrapper || !content) return null;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof ScrollSmoother === 'undefined') {
      return null;
    }

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return null;

    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    ScrollSmoother.get()?.kill();

    const smoother = ScrollSmoother.create({
      wrapper: '#babaa-smooth-wrapper',
      content: '#babaa-smooth-content',
      smooth: 0.5,
      smoothTouch: 0.08,
      normalizeScroll: true,
      effects: false,
      onUpdate: (self) => updateHeaderFixed(self.scrollTop()),
    });

    document.body.classList.add('babaa-shop-smooth-active');
    updateHeaderFixed(smoother.scrollTop());
    return smoother;
  };

  const initShopTiles = () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const grid = document.querySelector('.babaa-shop-grid');
    if (!grid || grid.dataset.tilesAnimated) return;
    grid.dataset.tilesAnimated = 'true';

    const tiles = gsap.utils.toArray('.babaa-shop-tile', grid);
    if (!tiles.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    gsap.registerPlugin(ScrollTrigger);

    const hero = tiles.find((tile) => tile.classList.contains('babaa-shop-tile--hero')) || tiles[0];
    const afterHero = tiles.filter((tile) => tile !== hero);

    gsap.set(hero, { y: 0, opacity: 1 });

    let animatedTiles = afterHero;
    if (isDesktop() && afterHero.length >= 2) {
      gsap.set(afterHero.slice(0, 2), { y: 0, opacity: 1 });
      animatedTiles = afterHero.slice(2);
    }

    if (!animatedTiles.length) return;

    gsap.set(animatedTiles, { y: 36, opacity: 0 });
    animatedTiles.forEach((tile) => tile.classList.add('babaa-shop-tile--animate'));

    const columns = isDesktop() ? 2 : 1;
    const stagger = isDesktop() ? 0.22 : 0.14;

    ScrollTrigger.batch(animatedTiles, {
      interval: 0.25,
      batchMax: columns,
      start: 'top 90%',
      once: true,
      onEnter: (batch) => {
        gsap.to(batch, {
          y: 0,
          opacity: 1,
          duration: 0.82,
          stagger,
          ease: 'power2.out',
          overwrite: 'auto',
          onComplete() {
            this.targets().forEach((tile) => {
              tile.classList.remove('babaa-shop-tile--animate');
              gsap.set(tile, { clearProps: 'transform' });
            });
          },
        });
      },
    });
  };

  const refreshScroll = () => {
    ScrollTrigger?.refresh(true);
    const smoother = ScrollSmoother?.get?.();
    if (smoother) updateHeaderFixed(smoother.scrollTop());
  };

  const teardown = () => {
    ScrollSmoother.get()?.kill();
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    document.body.classList.remove('babaa-shop-smooth-active');
    getHeaderShell()?.removeAttribute('data-shop-scroll-bound');
  };

  const boot = () => {
    const smoother = initSmoothScroll();
    if (!smoother) bindNativeHeaderScroll();
    initShopTiles();
    requestAnimationFrame(refreshScroll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', refreshScroll);

  document.addEventListener('shopify:section:load', (event) => {
    const grid = event.target?.querySelector?.('.babaa-shop-grid');
    if (!grid) return;
    delete grid.dataset.tilesAnimated;
    teardown();
    boot();
  });
})();
